// Demo Data Store — used when Firebase is not configured
// This simulates Firestore with in-memory data

// ============ Admin Settings ============
export let adminSettings = {
    bank_name: 'กสิกรไทย',
    account_name: 'บริษัท อองดูดวง จำกัด',
    account_number: 'XXX-X-XXXXX-X',
    promptpay_id: '0812345678',
    qr_code_url: '', // Will be set by admin
    service_note: 'กรุณาโอนเงินและส่งสลิปทาง LINE Chat'
};

export function updateAdminSettings(updates) {
    adminSettings = { ...adminSettings, ...updates };
    return adminSettings;
}

// ============ User Registry ============
// All users who have ever logged in — admin can change their roles
export let userRegistry = [
    {
        id: 'demo_user_001',
        name: 'ผู้ใช้ทดสอบ',
        pictureUrl: 'https://ui-avatars.com/api/?name=U&background=9b59f0&color=fff&size=200',
        role: 'customer',
        phone: '0812345678',
        createdAt: new Date().toISOString()
    }
];

export function findUserById(id) {
    return userRegistry.find(u => u.id === id);
}

export function registerUser(user) {
    const existing = findUserById(user.id);
    if (existing) return existing;
    userRegistry.push(user);
    return user;
}

export function updateUserRole(userId, role) {
    const user = findUserById(userId);
    if (user) {
        user.role = role;
    }
    return user;
}

export function getAdminUsers() {
    return userRegistry.filter(u => u.role === 'fortune_teller' || u.role === 'admin');
}

// ============ Fortune Tellers ============
export const demoFortuneTellers = [
    {
        id: 'ft_001',
        name: 'อาจารย์สมชาย',
        pictureUrl: 'https://ui-avatars.com/api/?name=FT&background=6b21a8&color=fff&size=200',
        specialty: 'ดูดวงไพ่ยิปซี, ดวงชะตา',
        rating: 4.8,
        reviewCount: 156,
        price: { onsite: 1500, chat: 500, call: 800, video: 1000 },
        bio: 'ประสบการณ์กว่า 15 ปี เชี่ยวชาญด้านดวงชะตา การงาน การเงิน และความรัก',
        available: true
    },
    {
        id: 'ft_002',
        name: 'แม่หมอมาลี',
        pictureUrl: 'https://ui-avatars.com/api/?name=FT&background=9b59f0&color=fff&size=200',
        specialty: 'ดูลายมือ, ไพ่ทาโรต์',
        rating: 4.9,
        reviewCount: 203,
        price: { onsite: 2000, chat: 700, call: 1000, video: 1500 },
        bio: 'ผู้เชี่ยวชาญไพ่ทาโรต์และลายมือ แม่นยำ ตรงประเด็น ให้คำแนะนำที่ปฏิบัติได้จริง',
        available: true
    },
    {
        id: 'ft_003',
        name: 'หมอดูวิชัย',
        pictureUrl: 'https://ui-avatars.com/api/?name=FT&background=e94d9e&color=fff&size=200',
        specialty: 'โหราศาสตร์ไทย, ฤกษ์มงคล',
        rating: 4.7,
        reviewCount: 89,
        price: { onsite: 1200, chat: 400, call: 600, video: 800 },
        bio: 'เชี่ยวชาญโหราศาสตร์ไทย ดูฤกษ์ ดูดวงรายปี วิเคราะห์ดวงชะตาเชิงลึก',
        available: true
    }
];

// ============ Schedules ============
function generateSchedule(ftId) {
    const schedules = [];
    const now = new Date();
    for (let i = 1; i <= 14; i++) {
        const date = new Date(now);
        date.setDate(date.getDate() + i);
        if (date.getDay() === 0) continue;

        const dateStr = formatDateStr(date);
        const slots = ['10:00', '11:00', '12:00', '13:00', '14:00'];

        schedules.push({
            fortune_teller_id: ftId,
            date: dateStr,
            slots: slots,
            booked_slots: []
        });
    }
    return schedules;
}

function formatDateStr(date) {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
}

export const demoSchedules = [
    ...generateSchedule('ft_001'),
    ...generateSchedule('ft_002'),
    ...generateSchedule('ft_003')
];

// ============ Bookings ============
export let demoBookings = [];

let bookingIdCounter = 1;

export function addDemoBooking(booking) {
    const id = `booking_${String(bookingIdCounter++).padStart(4, '0')}`;
    const newBooking = { id, ...booking, status: 'pending', createdAt: new Date().toISOString() };
    demoBookings.unshift(newBooking);

    // Mark slot as booked
    const schedule = demoSchedules.find(s => s.fortune_teller_id === booking.fortune_teller_id && s.date === booking.date);
    if (schedule) {
        schedule.booked_slots.push(booking.time);
    }

    return newBooking;
}

export function updateDemoBooking(id, updates) {
    const idx = demoBookings.findIndex(b => b.id === id);
    if (idx !== -1) {
        demoBookings[idx] = { ...demoBookings[idx], ...updates };
        return demoBookings[idx];
    }
    return null;
}

export function getAvailableSlots(ftId, dateStr) {
    const schedule = demoSchedules.find(s => s.fortune_teller_id === ftId && s.date === dateStr);
    if (!schedule) return [];
    return schedule.slots.filter(s => !schedule.booked_slots.includes(s));
}

export function getAvailableDates(ftId) {
    return demoSchedules
        .filter(s => s.fortune_teller_id === ftId)
        .filter(s => s.slots.length > s.booked_slots.length)
        .map(s => s.date);
}

export function getFortuneTeller(id) {
    return demoFortuneTellers.find(ft => ft.id === id);
}
